(function ($) { 

  Drupal.behaviors.mainFooter = {
	    attach: function (context) {
	    		Drupal.behaviors.mainFooterCreator(context);
	    }
}
  
  Drupal.behaviors.mainFooterCreator = function (context){
  	var mainContent = $(".mainFooter", context).first();
				    		
	    	var isAlreadyModified = $(mainContent).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}
	    	Drupal.behaviors.linkButtonCreator($(mainContent));
	    	Drupal.behaviors.iconCreator($(mainContent));
	    	Drupal.behaviors.logoImageCreator($(mainContent));
	    	Drupal.behaviors.timeAndTemperatureBlockCreator($(mainContent));
	    	$(mainContent).data("saph-done",true);
  }
  
  	Drupal.behaviors.changeFooterToHandheldMode = function () {
	  Drupal.behaviors.functions.consolog("Handheld Footer");
	  	//$(".linkButton", $(".mainFooter")).addClass("linkButton-edge");
	  	$(".linkButton", $(".mainFooter")).addClass("wholeElement");
	  	$(".linkButton .linkMainContainer", $(".mainFooter")).addClass("linkButton-edge");
	  	$(".linkButton .linkMainContainer", $(".mainFooter")).removeClass("singleElement");
	  	
	  	$(".linkButton .linkButtonDiv", $(".mainFooter")).removeClass("hideElement");
		$("#footerLogoCol", $(".mainFooter")).addClass("hideElement");
		$("#footerTimeCol", $(".mainFooter")).addClass("hideElement");
		
		$("#footerCopyrightCol", $(".mainFooter")).before($("#footerSocialCol",$(".mainFooter")));
	};
	Drupal.behaviors.changeFooterToTabletMode = function () {
		Drupal.behaviors.functions.consolog("Tablet Footer");
		//$(".linkButton", $(".mainFooter")).removeClass("linkButton-edge");
		$(".linkButton", $(".mainFooter")).removeClass("wholeElement");
		$(".linkButton .linkMainContainer", $(".mainFooter")).addClass("singleElement");
		$(".linkButton .linkMainContainer", $(".mainFooter")).removeClass("linkButton-edge");
		$(".linkButton .linkButtonDiv", $(".mainFooter")).addClass("hideElement");
		$("#footerLogoCol", $(".mainFooter")).addClass("hideElement");
		$("#footerTimeCol", $(".mainFooter")).addClass("hideElement");
		
		$("#footerOurArtistsCol", $(".mainFooter")).after($("#footerSocialCol",$(".mainFooter")));
	};
	Drupal.behaviors.changeFooterToDesktopMode = function () {
		Drupal.behaviors.functions.consolog("Desktop Footer");
		$(".linkButton", $(".mainFooter")).removeClass("wholeElement");
		$(".linkButton .linkMainContainer", $(".mainFooter")).addClass("singleElement");
		$(".linkButton .linkMainContainer", $(".mainFooter")).removeClass("linkButton-edge");
		$(".linkButton .linkButtonDiv", $(".mainFooter")).addClass("hideElement");
		$("#footerLogoCol", $(".mainFooter")).removeClass("hideElement");
		$("#footerTimeCol", $(".mainFooter")).removeClass("hideElement");
		
		$("#footerOurArtistsCol", $(".mainFooter")).after($("#footerSocialCol",$(".mainFooter")));
	};
  

})(jQuery);